import { LegalArea } from './models';

export const LEGAL_AREAS: LegalArea[] = [
  { slug: 'juicio-sucesorio', name: 'Juicio Sucesorio' },
  { slug: 'adjudicacion', name: 'Adjudicación de Bienes' },
  { slug: 'casos-especiales', name: 'Casos Especiales / Otros' }
];

